import React, { Component } from "react";

class UserCard extends Component {
  render() {
    const style = {
      background: this.props.style,
    };
    return (
      <div className="card text-center" style={style}>
        <div
          className="avatar"
          style={{
            backgroundImage: "url(" + this.props.img + ")",
            marginBottom: 16,
          }}
        />
        <p>
          <b>{this.props.title}</b>
        </p>
        <p>{this.props.content}</p>
      </div>
    );
  }
}

export default UserCard;
